import {
  Box,
  Card,
  CardMedia,
  Typography,
  Grid,
  Fade,
} from "@mui/material";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function GallerySection({
  plant,
  selectedImage,
  setSelectedImage,
}) {
  const images = [
    {
      title: "Bark",
      image: plant.gallery?.bark,
    },
    {
      title: "Leaf",
      image: plant.gallery?.leaf,
    },
    {
      title: "Flower",
      image: plant.gallery?.flower,
    },
    {
      title: "Fruit",
      image: plant.gallery?.fruit,
    },
    {
      title: "Seed",
      image: plant.gallery?.seed,
    },
  ].filter((item) => item.image);

  return (
    <Box mt={8}>
      {/* Heading */}

      <Typography
        align="center"
        sx={{
          fontSize: {
            xs: "2rem",
            md: "2.6rem",
          },
          fontWeight: 700,
          color: "#0B3C5D",
        }}
      >
        Plant Gallery
      </Typography>

      <Typography
        align="center"
        sx={{
          mt: 1,
          mb: 5,
          color: "text.secondary",
        }}
      >
        View different parts of the plant including bark,
        leaves, flowers, fruits and seeds.
      </Typography>

      <Grid
        container
        spacing={3}
        justifyContent="center"
      >
        {images.map((item) => {
          const active = selectedImage === item.image;

          return (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={2.4}
              key={item.title}
            >
              <Fade in timeout={500}>
                <Card
                  onClick={() =>
                    setSelectedImage(item.image)
                  }
                  elevation={0}
                  sx={{
                    cursor: "pointer",
                    borderRadius: 5,
                    overflow: "hidden",

                    border: active
                      ? "3px solid #2E7D32"
                      : "1px solid #E5ECE8",

                    boxShadow: active
                      ? "0 18px 40px rgba(46,125,50,.25)"
                      : "0 8px 25px rgba(0,0,0,.08)",

                    transition: ".35s",

                    "&:hover": {
                      transform:
                        "translateY(-8px)",
                      boxShadow:
                        "0 18px 45px rgba(0,0,0,.15)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={item.image}
                      alt={item.title}
                      sx={{
                        height: 220,
                        objectFit: "cover",
                        transition: ".5s",

                        "&:hover": {
                          transform:
                            "scale(1.08)",
                        },
                      }}
                    />

                    {active && (
                      <CheckCircleIcon
                        sx={{
                          position: "absolute",
                          top: 12,
                          right: 12,
                          fontSize: 34,
                          color: "#2E7D32",
                          bgcolor: "#fff",
                          borderRadius: "50%",
                        }}
                      />
                    )}
                  </Box>

                  <Box
                    sx={{
                      py: 2,
                      textAlign: "center",
                      background:
                        active
                          ? "#E8F5E9"
                          : "#fff",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: "#0B3C5D",
                        fontSize: "1.1rem",
                      }}
                    >
                      {item.title}
                    </Typography>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                    >
                     
                    </Typography>
                  </Box>
                </Card>
              </Fade>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}

export default GallerySection;